let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("o3ypa")).then(() => parcelRequire('hmt2h'));